export const SidebarUserIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9999 13.75C8.09396 13.75 5.50976 15.1531 3.86453 17.3305C3.51043 17.7991 3.33337 18.0334 3.33917 18.3501C3.34364 18.5948 3.49727 18.9034 3.68978 19.0545C3.93895 19.25 4.28424 19.25 4.97482 19.25H17.0249C17.7155 19.25 18.0608 19.25 18.3099 19.0545C18.5024 18.9034 18.6561 18.5948 18.6606 18.3501C18.6663 18.0334 18.4893 17.7991 18.1352 17.3305C16.49 15.1531 13.9057 13.75 10.9999 13.75Z"
      stroke="white"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 11C13.2782 11 15.125 9.15317 15.125 6.875C15.125 4.59683 13.2782 2.75 11 2.75C8.72183 2.75 6.875 4.59683 6.875 6.875C6.875 9.15317 8.72183 11 11 11Z"
      stroke="white"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
